const PHRASES = [
  "Get the water out",
  "Sort insurance in parallel",
  "Mitigation protects the claim",
  "Waiting is the one thing that works against both",
];

export const Marquee = () => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-erg-mid/30 py-5 overflow-hidden marquee-mask"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {items.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-semibold uppercase tracking-wide text-erg-dry/85 text-xl sm:text-2xl px-6">
              {p}
            </span>
            <span className="text-erg-ember text-xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
